<div class="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
     (click)="onCancel()">
  <div class="bg-white dark:bg-app-black-500 rounded shadow-lg w-[640px] max-w-[95vw] max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-[#434863]"
       (click)="$event.stopPropagation()">
    <div class="py-3 px-6 dark:bg-app-black-100 rounded-t flex items-start justify-between gap-3">
      <div class="min-w-0">
        <h1 class="text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-xl dark:text-white">
          <i class="fa-solid fa-shield-halved text-app-teal-100 mr-2"></i> {{ title }}
        </h1>
        <div *ngIf="userDisplayName || userEmail || userPoolName" class="mt-1 leading-tight">
          <div *ngIf="userDisplayName" class="text-sm font-medium text-gray-800 dark:text-gray-100">
            {{ userDisplayName }}
          </div>
          <div *ngIf="userEmail" class="text-xs text-gray-500 dark:text-gray-400">
            {{ userEmail }}
          </div>
          <div *ngIf="userPoolName" class="text-[10px] uppercase tracking-wide text-app-teal-100 mt-0.5">
            Pool: {{ userPoolName }}
          </div>
        </div>
      </div>
      <div *ngIf="cards.length" class="flex items-center gap-2 flex-shrink-0 mt-1">
        <button type="button" (click)="expandAll()"
                class="text-[10px] uppercase tracking-wide text-app-teal-100 hover:text-app-teal-200">
          <i class="fa-solid fa-chevron-down mr-1"></i>Expand all
        </button>
        <span class="text-[10px] text-gray-400">·</span>
        <button type="button" (click)="collapseAll()"
                class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 hover:text-gray-300">
          <i class="fa-solid fa-chevron-right mr-1"></i>Collapse all
        </button>
      </div>
    </div>

    <div class="py-4 px-6 dark:bg-gradient-to-b dark:from-app-black-200 dark:to-app-black-300 text-sm">
      <p *ngIf="cards.length === 0" class="mb-4 text-xs text-gray-500 dark:text-gray-400">
        No customers compatible with this user's Cognito pool. (Customers on other
        pools are excluded because the user can't be granted access to them
        without re-provisioning in their pool.)
      </p>

      <div *ngFor="let card of cards"
           class="mb-3 border rounded transition-colors"
           [ngClass]="card.enabled
             ? 'border-app-teal-100 bg-white dark:bg-app-black-100'
             : 'border-gray-300 dark:border-app-black-100 bg-white dark:bg-app-black-100'">
        <div class="flex items-center justify-between px-3 py-2 cursor-pointer select-none"
             (click)="onHeaderToggle(card)">
          <label class="flex items-center gap-2 cursor-pointer min-w-0"
                 (click)="$event.stopPropagation()">
            <input type="checkbox"
                   [checked]="card.enabled"
                   [disabled]="card.isOwnPool"
                   (change)="toggleCardEnabled(card, $any($event.target).checked)"
                   class="cursor-pointer flex-shrink-0"
                   [title]="card.isOwnPool ? 'Locked: this is the user’s own customer pool' : ''" />
            <div class="flex flex-col min-w-0">
              <span class="text-sm font-medium truncate"
                    [ngClass]="card.enabled ? 'text-gray-900 dark:text-white' : 'text-gray-700 dark:text-gray-300'">
                {{ card.customer.name || card.customer._id }}
                <span *ngIf="card.isOwnPool" class="ml-1 text-[10px] uppercase tracking-wide text-app-teal-100">own pool</span>
              </span>
              <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
                {{ card.customer._id }} • {{ card.scanners.length }} scanner{{ card.scanners.length === 1 ? '' : 's' }}
              </span>
            </div>
          </label>
          <div class="flex items-center gap-2 flex-shrink-0">
            <span *ngIf="card.enabled" class="text-[11px] text-gray-500 dark:text-gray-400">
              {{ cardSummary(card) }}
            </span>
            <i class="fa-solid text-xs text-gray-500 dark:text-gray-400"
               [class.fa-chevron-down]="card.expanded"
               [class.fa-chevron-right]="!card.expanded"></i>
          </div>
        </div>

        <div *ngIf="card.enabled && card.expanded" class="px-3 pb-3 border-t border-gray-200 dark:border-app-black-100">
          <!-- Wildcard "include all" + Select-all/Clear actions. -->
          <div class="mt-3 flex items-center justify-between mb-2 gap-3">
            <label class="inline-flex items-center gap-2 text-xs text-gray-900 dark:text-white cursor-pointer">
              <input type="checkbox"
                     [checked]="card.wildcardChecked"
                     (change)="toggleWildcard(card, $any($event.target).checked)" />
              <span>Include all (wildcard <code class="text-[10px]">{{ card.wildcard }}</code>)</span>
            </label>
            <div class="flex items-center gap-2">
              <button type="button" (click)="selectAll(card)"
                      class="text-[10px] uppercase tracking-wide text-app-teal-100 hover:text-app-teal-200">
                Select all
              </button>
              <span class="text-[10px] text-gray-400">·</span>
              <button type="button" (click)="clearAll(card)"
                      class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 hover:text-gray-300">
                Clear
              </button>
            </div>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            <label *ngFor="let s of card.scanners"
                   class="inline-flex items-start gap-2 text-xs text-gray-900 dark:text-white border border-gray-200 dark:border-[#434863] rounded px-2 py-1.5 cursor-pointer hover:border-app-teal-100"
                   [class.opacity-60]="isScannerDisabled(card)">
              <input type="checkbox"
                     [checked]="isScannerChecked(card, $any(s._id || s.Id))"
                     [disabled]="isScannerDisabled(card)"
                     (change)="toggleScanner(card, $any(s._id || s.Id))"
                     class="mt-0.5 cursor-pointer flex-shrink-0" />
              <div class="flex flex-col min-w-0">
                <span class="truncate font-medium">{{ s.Name || s._id || s.Id }}</span>
                <span class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400 truncate">
                  {{ s._id || s.Id }}
                </span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <!-- Orphan scanner tokens (excluded customers / mismatched pool). -->
      <div *ngIf="orphanScannerTokens.length" class="mt-3">
        <h3 class="text-xs uppercase tracking-wide text-amber-500 mb-2 flex items-center gap-2">
          <i class="fa-solid fa-triangle-exclamation"></i>
          Other scanner tokens
          <span class="text-[10px] normal-case text-gray-500 dark:text-gray-400">
            (not visible — different pool or unknown customer; preserved on save)
          </span>
        </h3>
        <div class="flex flex-wrap gap-2">
          <span *ngFor="let t of orphanScannerTokens"
                class="inline-flex items-center gap-1 text-xs bg-amber-500/10 border border-amber-500/40 text-amber-700 dark:text-amber-300 rounded px-2 py-0.5">
            {{ t }}
            <button type="button" (click)="removeOrphan(t)"
                    class="text-amber-500 hover:text-amber-400" aria-label="Remove">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mt-6 flex gap-2 justify-end items-center">
        <span *ngIf="saving" class="text-[11px] text-app-teal-100 mr-2 flex items-center gap-1.5">
          <i class="fa-solid fa-circle-notch fa-spin"></i>
          Saving…
        </span>
        <button type="button" (click)="onCancel()" [disabled]="saving"
                class="dark-btn-secondary text-xs px-3 py-1 disabled:opacity-50 disabled:cursor-not-allowed">cancel</button>
        <button type="button" (click)="onSave()" [disabled]="saving"
                class="dark-btn-primary text-xs px-3 py-1 disabled:opacity-50 disabled:cursor-not-allowed">
          <i *ngIf="saving" class="fa-solid fa-circle-notch fa-spin mr-1"></i>
          {{ saving ? 'saving…' : 'save' }}
        </button>
      </div>
    </div>
  </div>
</div>
